/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { markEnum } from "igniteui-react-core";
export var CheckboxListIndexType = /*@__PURE__*/ (function (CheckboxListIndexType) {
    CheckboxListIndexType[CheckboxListIndexType["Selected"] = 0] = "Selected";
    CheckboxListIndexType[CheckboxListIndexType["DeSelected"] = 1] = "DeSelected";
    return CheckboxListIndexType;
})({});
/**
 * @hidden
 */
export var CheckboxListIndexType_$type = /*@__PURE__*/ markEnum('CheckboxListIndexType', 'Selected,0|DeSelected,1');
//# sourceMappingURL=CheckboxListIndexType.js.map
